import { useEffect } from "react";
import { Loader2, RotateCcw, SquareArrowOutUpRight } from "lucide-react";

import { MessageType } from "shared/types";
import { getText } from "shared/lib";

import { useCouncilLocalisation } from "shared/hooks";
import {
  CaptureEventType,
  useAccount,
  useCancelOrCompleteApplication,
  useCaptureEvent,
  useFindMessageOfType,
} from "@/hooks";

import { Button, Dialog, DialogContent, DialogTitle } from "shared/components";

export function SystemErrorDialog() {
  const { captureEvent } = useCaptureEvent();

  const { conversation } = useAccount();
  const { getLocalisationEntry } = useCouncilLocalisation(conversation);

  const systemErrorMessage = useFindMessageOfType({
    messageType: MessageType.SYSTEM_ERROR,
  });

  useEffect(() => {
    if (systemErrorMessage?.id) {
      captureEvent(CaptureEventType.USER_SYSTEM_ERROR_RENDERED, {
        messageId: systemErrorMessage?.id,
        uuid: systemErrorMessage?.id,
      });
    }
  }, [systemErrorMessage?.id]); // eslint-disable-line

  const {
    isPending: cancelOrCompleteApplicationLoading,
    cancelOrCompleteApplication,
  } = useCancelOrCompleteApplication({});

  const handleClickRestart = () => {
    if (cancelOrCompleteApplicationLoading) {
      return;
    }

    console.log("<SystemErrorDialog> handleClickRestart()");
    cancelOrCompleteApplication();
  };

  return (
    <div className="flex h-full flex-col">
      <Dialog open modal={false}>
        <DialogContent
          aria-describedby={undefined}
          className="!rounded-xl md:max-w-[600px]"
          hideCloseButton
        >
          <DialogTitle>{getText("🤕 We're sorry, something went wrong")}</DialogTitle>

          <div className="flex flex-col gap-4">
            {/*<p*/}
            {/*  className="text-bodymd text-textPrimary [&_a]:text-textLink [&_a]:hover:text-textLinkHover [&_a]:underline"*/}
            {/*  dangerouslySetInnerHTML={{*/}
            {/*    __html: systemErrorMessage?.text || "",*/}
            {/*  }}*/}
            {/*/>*/}

            <p className="text-bodymd text-textPrimary [&_a]:text-textLink [&_a]:hover:text-textLinkHover [&_a]:underline">
              {getText("An error occurred on our end that we couldn't resolve. We'll get this fixed soon. Please restart, or if you continue to see this error, talk to a planner about your proposal.")}
            </p>

            <div className="flex justify-end gap-[12px]">
              <Button asChild variant="outline">
                <a
                  href={getLocalisationEntry("councilContactLink")}
                  rel="noreferrer"
                  target="_blank"
                >
                  {getText("Talk to a planner")}{" "}
                  <SquareArrowOutUpRight className="h-4 w-4" />
                </a>
              </Button>

              <Button onClick={handleClickRestart}>
                {cancelOrCompleteApplicationLoading && (
                  <>
                    <Loader2 className="animate-spin" />{" "}
                  </>
                )}
                {getText("Restart")}
                <RotateCcw className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <div className="flex-grow" />

      {/*<div className="mt-3 flex justify-end">*/}
      {/*  <Button disabled>Continue</Button>*/}
      {/*</div>*/}

      <div className="absolute inset-0 z-50 bg-black/25" />
    </div>
  );
}
